import { useTranslation } from 'react-i18next';

// Import components
import DeleteNpvrRecording from './DeleteNpvrRecording';
import LinkWrapper from '../LinkWrapper';
import { ModalCloseButton } from 'components/views/offer_configurator/components/common/modals/components/ModalCloseButton';

// Import actions
import { clearNpvrRecordingsErrors } from 'store/actions';

// Import helpers
import { convertDuration } from 'helpers/time';

// Import utilities
import useToggle from 'components/utilities/hooks/toggle/useToggle';

// Import hooks
import { useAppDispatch } from 'store/hooks';

// Import assets
import SliderItemPlaceholder from 'assets/images/slider_item_placeholder_landscape.png';

// Import styles
import { Wrapper, Item, Info, DeleteButton, TrashIconStyled } from '../style';
import { AntModalStyled, ModalContent, StyledTitle, ButtonContainer } from 'components/views/offer_configurator/components/common/modals/styles';

// Import types
import type { Recording } from 'types/views/recordings';

const ItemDetailsNpvr = ({ channelTitle, duration, recordingName, recordingId, backgroundImage, date, time, status, url }: Recording) => {
	const { t } = useTranslation();
	const [isOpened, toggle] = useToggle(false);
	const dispatch = useAppDispatch();

	const recordingLength = convertDuration(duration, 'long');
	const pendingInfo = `${channelTitle} | ${date} | ${time}`;
	const readyInfo = `${channelTitle} ${recordingLength ? `| ${recordingLength}` : ''}`;

	const handleCloseModal = () => {
		clearNpvrRecordingsErrors()(dispatch);
		toggle();
	};

	const backgroundImageUrl = backgroundImage || SliderItemPlaceholder;

	return (
		<>
			<LinkWrapper status={status} url={url}>
				<Wrapper backgroundImageUrl={backgroundImageUrl} className="hover-wrap">
					<Item className="hover-item">
						{status === 'ready' && <Info title={readyInfo}>{readyInfo}</Info>}
						{status === 'pending' && <Info title={pendingInfo}>{pendingInfo}</Info>}
						<Info title={recordingName}>{recordingName}</Info>
					</Item>
				</Wrapper>
			</LinkWrapper>
			<DeleteButton onClick={toggle}>
				<TrashIconStyled />
			</DeleteButton>
			<AntModalStyled visible={isOpened} closable={false} footer={null} centered>
				<ModalCloseButton closeModal={handleCloseModal} />
				<ModalContent>
					<StyledTitle>{t('recordings_npvr_confirm_delete_recording')}</StyledTitle>
					<ButtonContainer>
						<DeleteNpvrRecording recordingId={recordingId} closeModal={handleCloseModal} />
					</ButtonContainer>
				</ModalContent>
			</AntModalStyled>
		</>
	);
};

export default ItemDetailsNpvr;
